import constants from '../../constants';
const getPRAConfiguration = (praType) => {
    var _a;
    const currentBrand = ((_a = process.env.BRAND_PREFIX) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'hm';
    const result = constants.PRA.find((pra) => pra.ID === praType.toUpperCase() && pra.BRAND === currentBrand);
    return result;
};
export default getPRAConfiguration;
//# sourceMappingURL=getPRAConfiguration.js.map